// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__pg-RL","active":"MyModal_active__9tL7C","myModalContent":"MyModal_myModalContent__gQngB"};